/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrSerialClaimsInfo
 */
export interface RttrSerialClaimsInfo {
    /**
     * 
     * @type {number}
     * @memberof RttrSerialClaimsInfo
     */
    existingCount: number;
    /**
     * 
     * @type {number}
     * @memberof RttrSerialClaimsInfo
     */
    existingMax: number;
    /**
     * 
     * @type {number}
     * @memberof RttrSerialClaimsInfo
     */
    newPurchasePts: number;
    /**
     * 
     * @type {number}
     * @memberof RttrSerialClaimsInfo
     */
    newPurchaseMaxPts: number;
}

/**
 * Check if a given object implements the RttrSerialClaimsInfo interface.
 */
export function instanceOfRttrSerialClaimsInfo(value: object): value is RttrSerialClaimsInfo {
    if (!('existingCount' in value) || value['existingCount'] === undefined) return false;
    if (!('existingMax' in value) || value['existingMax'] === undefined) return false;
    if (!('newPurchasePts' in value) || value['newPurchasePts'] === undefined) return false;
    if (!('newPurchaseMaxPts' in value) || value['newPurchaseMaxPts'] === undefined) return false;
    return true;
}

export function RttrSerialClaimsInfoFromJSON(json: any): RttrSerialClaimsInfo {
    return RttrSerialClaimsInfoFromJSONTyped(json, false);
}

export function RttrSerialClaimsInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrSerialClaimsInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'existingCount': json['existingCount'],
        'existingMax': json['existingMax'],
        'newPurchasePts': json['newPurchasePts'],
        'newPurchaseMaxPts': json['newPurchaseMaxPts'],
    };
}

export function RttrSerialClaimsInfoToJSON(json: any): RttrSerialClaimsInfo {
    return RttrSerialClaimsInfoToJSONTyped(json, false);
}

export function RttrSerialClaimsInfoToJSONTyped(value?: RttrSerialClaimsInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'existingCount': value['existingCount'],
        'existingMax': value['existingMax'],
        'newPurchasePts': value['newPurchasePts'],
        'newPurchaseMaxPts': value['newPurchaseMaxPts'],
    };
}

